export default function NoneSelect({children}) {
  return <div style={{userSelect: 'none'}}>{children}</div>
}